import { Component, OnInit, Input, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef, Output,
    EventEmitter } from '@angular/core';

@Component({
    selector: 'eui-uploaded-file',
    templateUrl: './uploaded-file.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class EuiUploadedFileComponent implements OnInit {
    @Input() file: any;
    @Input() index: number;
    @Input() hasPreview = true;
    @Input() isFilenameDisplayed = true;
    @Input() isFilesizeDisplayed = true;
    @Input() isFiletypeDisplayed = true;
    @Input() hasPreviewAsImage = true;
    @Input() hasPreviewAsIcon = false;

    @Input() previewAsIconConfig = {
        'image/jpeg': 'fa-picture-o',
        'image/gif': 'fa-picture-o',
        'image/png': 'fa-picture-o',
        'application/msword': 'fa-file-word-o',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'fa-file-word-o',
        'application/vnd.ms-excel': 'fa-file-excel-o',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'fa-file-excel-o',
        'application/pdf': 'fa-file-pdf-o',
    };

    @Output() removeFromList = new EventEmitter<number>();

    public url: string;
    public icon: string;
    public previewData: { image: boolean, display: string };

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit() {
        if (this.hasPreviewAsIcon) {
            this.hasPreviewAsImage = false;
        }

        const reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onload = (event: any) => {
            this.url = event.target.result;
            this.icon = this.getIconForMime(this.file.type);
            this.previewData = this.getPreviewForMime(this.file.type);
            this.cd.detectChanges();
        };
    }

    public onRemoveFromList() {
        this.removeFromList.emit(this.index);
    }

    private getPreviewForMime(mime: string) {
        const image = mime === 'image/jpeg' || mime === 'image/gif' || mime === 'image/png' ? true : false;

        const display = mime === 'image/jpeg' || mime === 'image/gif' || mime === 'image/png' ?
                                    this.url :
                                    this.getIconForMime(mime);

        return { image, display };
    }

    private getIconForMime(mime: string) {
        return !this.previewAsIconConfig[mime] ? 'fa-file-o' : this.previewAsIconConfig[mime];
    }
}
